import React, {useState, useEffect, useMemo} from 'react'
import PropTypes from 'prop-types'
import {useAccessToken} from '@salesforce/commerce-sdk-react'
import {Box, Heading, Text} from '@chakra-ui/react'
import RecommendedProducts from '../../../../components/recommended-products'
import Link from '@salesforce/retail-react-app/app/components/link'
import {pxToRem} from '../../../../utills/pxToRem'
import {fonts} from '../../../../theme/foundations/fonts'
import useCustomFetch from '../../../../hooks/useFetchContent'
import {promoTilesContainer} from './index.style'
import {useLocation} from 'react-router-dom'
import {getUrlSearchParam} from '../../../../utills/url'
import LoadingSpinner from '../../../../components/loading-spinner'

function NoSearchResults({suggestedSearchQuery, searchQuery}) {
    const {token} = useAccessToken()
    const {response, loading} = useCustomFetch(token, 'no-search-result-promotion-tiles')
    const [promoTiles, setPromoTiles] = useState([])
    const location = useLocation()

    useEffect(() => {
        if (response) {
            const parser = new DOMParser()
            const tileElements = parser
                .parseFromString(response, 'text/html')
                .querySelectorAll('.promotional-tile')
            setPromoTiles(Array.from(tileElements, (tile) => tile.outerHTML))
        }
    }, [response])

    const previousSearchParams = useMemo(() => {
        const {snitizeUrlSearchParam} = getUrlSearchParam(location.search)
        return snitizeUrlSearchParam
    }, [location.search])

    return (
        <Box>
            <Heading
                as={'h1'}
                fontSize={[pxToRem(22), pxToRem(22), pxToRem(30), pxToRem(30)]}
                fontStyle="normal"
                fontWeight={600}
                lineHeight="normal"
                letterSpacing={[pxToRem(3), pxToRem(3), pxToRem(4), pxToRem(4)]}
                textTransform="uppercase"
                marginBottom={[pxToRem(29), pxToRem(29), pxToRem(25), pxToRem(25)]}
                fontFamily={fonts.primary}
                color="black"
            >
                we’re sorry, We scoured the range but didn’t find a match for &quot;{searchQuery}
                &quot;
            </Heading>
            {suggestedSearchQuery && (
                <Text
                    color="black"
                    fontFamily={fonts.primary}
                    fontSize={[pxToRem(14), pxToRem(14), pxToRem(16), pxToRem(16)]}
                    fontStyle="normal"
                    fontWeight={400}
                    lineHeight="normal"
                    letterSpacing={pxToRem(1)}
                    marginBottom={[pxToRem(60), pxToRem(60), pxToRem(80), pxToRem(80)]}
                >
                    Did you mean:{' '}
                    <Link
                        to={`/search?q=${suggestedSearchQuery}`}
                        textTransform="uppercase"
                        _hover={{
                            color: 'cav_hover_brightred',
                            textDecoration: 'underline'
                        }}
                    >
                        {suggestedSearchQuery}?
                    </Link>
                </Text>
            )}
            {loading ? (
                <LoadingSpinner />
            ) : (
                <>
                    <RecommendedProducts
                        title="Recommended for you"
                        recommender="best-sellers-null-results"
                        previousSearchParams={previousSearchParams}
                        showQuickView={true}
                    />
                    <Box sx={promoTilesContainer}>
                        {promoTiles?.map((tileHtml, index) => (
                            <Box key={index} dangerouslySetInnerHTML={{__html: tileHtml}} />
                        ))}
                    </Box>
                </>
            )}
        </Box>
    )
}

NoSearchResults.propTypes = {
    suggestedSearchQuery: PropTypes.string,
    searchQuery: PropTypes.string
}

export default NoSearchResults
